<div class="page">
    <app-header title="{{ 'usersModule.title' | translate }}"> </app-header>
    <ngx-loading [show]="showSpinner"></ngx-loading>

    <div class="page-content">
        <div class="table-top">
            <div class="section-header">{{ "usersModule.title" | translate }}</div>
            <app-button *ngIf="isVisible" [title]="'usersModule.addUser' | translate" (buttonClick)="addNewUser()" icon="fa-plus">
            </app-button>
        </div>
        <div class="table-body">
            <table class="table table-striped table-bordered">
                <thead>
                    <tr class="table-names">
                        <th>{{ "usersModule.firstAndLastName" | translate }}</th>
                        <th>{{ "usersModule.email" | translate }}</th>
                        <th>{{ "usersModule.role" | translate }}</th>
                        <th>{{ "status" | translate }}</th>
                        <th>{{ "actions" | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let userInvite of users; let i = index"
                        [ngClass]="userInvite.isCurrentUser ? 'inactiveTableRow table-row' : 'table-row'">
                        <th>{{ userInvite.fullName }}</th>
                        <th>{{ userInvite.email }}</th>
                        <th class="text-center">
                            {{ translate.instant(userInvite.role) }}
                        </th>
                        <th class="text-center">
                            {{ translate.instant(userInvite.currentStatus) }}
                        </th>
                        <th class="text-center">
                            <div *ngIf="(userInvite.currentStatus == userStatus.ToBeConfirmed) && currentUser.currentRole == userRoles.Admin">
                                <app-button icon="fa-check" [disable]="userInvite.confirmUserIWSignatureInProgress"
                                            [info]="confirmUserMessageTooltipTitle(userInvite)"
                                            (buttonClick)="confirmUser(userInvite)">
                                </app-button>
                            </div>

                            <app-button icon="fa-angle-right" (buttonClick)="editUserClick(userInvite)"
                                        *ngIf="(userInvite.currentStatus == userStatus.Registered || userInvite.currentStatus == userStatus.Revoked || userInvite.currentStatus == userStatus.Blocked) && !userInvite.isCurrentUser && currentUser.currentRole == userRoles.Admin"
                                        [info]="translate.instant('usersModule.editUserTitle')"></app-button>

                            <app-button icon="fa-trash" (click)="removeUser(userInvite)"
                                        *ngIf="shouldEliminateUserOptionBeShown(userInvite)"
                                        [info]="translate.instant('usersModule.eliminateUserTitle')"></app-button>
                        </th>
                    </tr>
                </tbody>
            </table>
        </div>
        <app-pagination 
        [options]="options" 
        [pagedList]="usersGrid.apiEnabledInvites"
        [callback]="loadData"
        ></app-pagination>
    </div>
</div>